// extracted by mini-css-extract-plugin
export default {"horizontal":"UserDetailsView_horizontal__3wiGw","avatar":"UserDetailsView_avatar__Wa4pq"};